import type { Account } from '@modules-deprecated/app/accounts/types'
import type { TaxRate } from '@modules-deprecated/app/taxrates/types'

import type { ReviewEntryLine } from '../types/reviewEntryLine'
import { enrichReviewEntryLineMetadata } from './enrichReviewEntryLineMetadata'
import { getMatchedTaxRate, getMatchedVatRateId } from './getMatchedVatRateId'

interface GetReviewEntryLineDefaultValuesOptions {
  accounts: Account[]
  line: ReviewEntryLine
  purchaseTaxRates: TaxRate[]
}

export const getReviewEntryLineDefaultValues = (options: GetReviewEntryLineDefaultValuesOptions) => {
  const { accounts, line, purchaseTaxRates } = options

  const amountExclVat = line.amountExclVat ?? line.amountExclTax
  const vatAmount = line.vatAmount ?? line.taxAmount
  const vatRateId =
    getMatchedVatRateId({
      taxRateId: line.taxRateId,
      taxRateLabel: line.taxRateLabel,
      vatRates: purchaseTaxRates,
    }) ||
    line.taxRateId ||
    ''
  // hydrate `taxRate` in lockstep with `vatRateId` so a matched entry doesn't require the
  // user to re-select the VAT rate just to satisfy the required-field validation
  const matchedRate =
    getMatchedTaxRate({
      taxRateId: line.taxRateId,
      taxRateLabel: line.taxRateLabel,
      vatRates: purchaseTaxRates,
    }) ?? (amountExclVat != null && amountExclVat > 0 && vatAmount != null ? vatAmount / amountExclVat : undefined)

  const { accountNumber, vatAccountNumber } = enrichReviewEntryLineMetadata({
    accountId: line.accountId ?? '',
    accountNumber: line.accountNumber,
    accounts,
    taxRates: purchaseTaxRates,
    vatAccountNumber: line.vatAccountNumber,
    vatRateId,
  })

  return {
    accountId: line.accountId ?? '',
    accountName: line.accountName,
    accountNumber,
    amountExclVat,
    amountInclVat: line.amountInclVat ?? line.amountInclTax,
    description: line.description ?? '',
    side: line.side ?? 'debit',
    taxRate: matchedRate,
    vatAmount,
    vatAccountNumber,
    vatRateId,
  }
}
